// extracted by mini-css-extract-plugin
module.exports = {"content":"tooltip-v2_content__ZxN_h","arrow":"tooltip-v2_arrow__o6gAZ"};